import Crud from '../views/ClientUnit/Crud'
import Entity from '../views/ClientUnit/Add'

let routes = {
    path: '/client_units',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/client_units/add',
            name: 'NewClientUnit',
            component: Entity,
            meta: {
                pageTitle: 'Unidade',
                breadcrumb: [
                    { text: 'Unidade', active: false, to: '/client_units' },
                    { text: 'Adicionar Unidade', active: true }
                ],
            },
        },
        {
            path: '/client_units/edit/:id?',
            name: 'EditClientUnit',
            component: Entity,
            meta: {
                pageTitle: 'Unidade',
                breadcrumb: [
                    { text: 'Unidade', active: false, to: '/client_units' },
                    { text: 'Editar Unidade', active: true }
                ],
            },
        },
        {
            path: '/client_units',
            name: 'list-client-units',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Unidade', active: true },
                ],
            },
        },
    ]
};

export default routes
